import React from 'react'
import clsx from 'clsx'
import {CityImprovementTypes} from '@colonist/game-states'
import styles from './UIGameCityImprovementTrackerMetropolisTriangle.module.scss'

export interface UIGameCityImprovementTrackerMetropolisTriangleProps {
    cityImprovementType: CityImprovementTypes
    className?: string
}
export function UIGameCityImprovementTrackerMetropolisTriangle({
    cityImprovementType,
    className,
}: UIGameCityImprovementTrackerMetropolisTriangleProps) {
    const cityImprovementTypeText = CityImprovementTypes[cityImprovementType].toLowerCase()
    return <div className={clsx(styles.triangleContainer, className)}>
        <div className={styles.border} />
        <div className={clsx(styles.background, styles[cityImprovementTypeText])} />
    </div>
}
